import { forwardRef } from "react";
import {
  Separator as ChakraDivider,
  type SeparatorProps as ChakraDividerProps,
} from "@chakra-ui/react";
import type { DividerSharedProps } from "./Divider.props";

export type DividerProps = DividerSharedProps & ChakraDividerProps;

const Divider = forwardRef<HTMLHRElement, DividerProps>(function Divider(
  { orientation, ...props },
  ref
) {
  return (
    <ChakraDivider
      ref={ref}
      borderColor="border"
      orientation={orientation}
      {...props}
    />
  );
});

export default Divider;
